import React, { useContext, useEffect, useState } from "react";
import { ThemeContext } from "../../../context/ThemeContext";
import img1 from "../../../assets/header.png";
import "../../../pages/Landing/LandingPage.css";
import AOS from "aos";

const Intro = () => {
  const { darkMode } = useContext(ThemeContext);
  const [isFirstLoad, setIsFirstLoad] = useState(true);

  useEffect(() => {
    // Check if this is the first load
    const hasVisited = sessionStorage.getItem("hasVisitedBefore");
    if (!hasVisited) {
      sessionStorage.setItem("hasVisitedBefore", "true");
      setIsFirstLoad(true);
    } else {
      setIsFirstLoad(false);
    }

    // Initialize AOS
    AOS.init({
      once: true,
      disable: !isFirstLoad, // Disable animations if not first load
      duration: 1000,
      delay: 100,
    });
  }, [isFirstLoad]);

  return (
    <section
      className={`hero-section position-relative ${
        darkMode ? "dark-mode" : ""
      }`}
      id="home"
    >
      <div className="container-fluid">
        <div className="row align-items-center min-vh-100 hero-row">
          <div className="col-12 col-lg-6 order-2 order-lg-1">
            <div className="hero-content text-center text-lg-start">
              <div
                className={`animate-wrapper ${
                  isFirstLoad ? "animate" : "no-animate"
                }`}
                data-aos={isFirstLoad ? "fade-right" : ""}
                data-aos-delay="100"
              >
                <h1
                  className={`hero-title ${darkMode ? "dark-mode-text" : ""}`}
                >
                  Complete Accounting & Business Management Solution
                </h1>
              </div>
              <div
                className={`animate-wrapper ${
                  isFirstLoad ? "animate" : "no-animate"
                }`}
                data-aos={isFirstLoad ? "fade-right" : ""}
                data-aos-delay="200"
              >
                <p
                  className={`hero-text ${
                    darkMode ? "dark-mode-text-secondary" : ""
                  }`}
                >
                  Our platform streamlines your financial operations with
                  integrated sales, purchases, inventory, and accounting tools.
                  Manage your entire business cycle from quotes to payments,
                  create detailed reports, and make data-driven decisions with
                  our powerful analytics.
                </p>
              </div>
              <div
                className={`animate-wrapper ${
                  isFirstLoad ? "animate" : "no-animate"
                }`}
                data-aos={isFirstLoad ? "fade-right" : ""}
                data-aos-delay="300"
              >
                <div className="hero-actions d-flex justify-content-center justify-content-lg-start">
                  <a
                    href="#get-started"
                    className={`get-started-btn ${
                      darkMode ? "dark-mode-btn-primary" : ""
                    }`}
                  >
                    Get Started
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-6 order-1 order-lg-2">
            <div
              className={`animate-wrapper ${
                isFirstLoad ? "animate" : "no-animate"
              }`}
              data-aos={isFirstLoad ? "fade-left" : ""}
              data-aos-delay="200"
            >
              <div className="hero-image-container text-center text-lg-start">
                <img
                  src={img1}
                  alt="Financial Management Dashboard"
                  className="hero-image img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        /* Mobile-specific improvements */
        @media (max-width: 767.98px) {
          /* Reduce overall section padding and row height */
          .hero-section { padding-top: 16px; padding-bottom: 24px; }
          .hero-row { min-height: auto !important; row-gap: 12px; }

          /* Tighten spacing between image and text */
          .hero-image-container { margin-bottom: 8px; }
          .hero-content { margin-top: 0; text-align: left !important; }
          .hero-actions { justify-content: flex-start !important; }

          /* Typography tuning */
          .hero-title {
            font-size: 28px; /* optimize for mobile */
            line-height: 1.25;
            font-weight: 800;
            letter-spacing: -0.2px;
            margin-bottom: 10px;
          }

          .hero-text {
            font-size: 14px;
            line-height: 1.55;
            max-width: 680px;
            margin-bottom: 14px;
          }
        }

        /* Small mobile */
        @media (max-width: 575.98px) {
          .hero-title {
            font-size: 24px;
            line-height: 1.3;
          }

          .hero-text {
            font-size: 13px;
          }
        }
      `}</style>
    </section>
  );
};

export default Intro;
